import { memo } from 'react';

import { FooterNavGroup } from './FooterNavGroup';

export * from './FooterNavGroup';

export default memo(FooterNavGroup);
